module.exports = __webpack_public_path__ + "mainassets/img/404-bg.60adb3ef.svg";